var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.6000106,12.1223776 L1.60119632,12.8727771 C2.02094012,12.7288238 2.5045946,12.824366 2.83950305,13.1594034 C3.17586827,13.4958982 3.27074315,13.9824936 3.12412769,14.4036628 L3.86652379,14.4055598 L5.10694412,13.1646617 L2.8335721,10.8904141 C2.08699669,11.6360174 1.6000106,12.1223776 1.6000106,12.1223776 Z M10.5339104,3.20094505 L12.8014453,5.46719672 L6.23803651,12.0331336 L3.96562228,9.75984421 C6.61228921,7.11665323 10.5339104,3.20094505 10.5339104,3.20094505 Z M13.2646091,0.469194741 L15.5310751,2.73653362 C16.1557553,3.36145434 16.1565044,4.37390161 15.532144,4.99850245 L4.81680205,15.7179716 C4.66110203,15.8737316 4.35710946,16 4.13244168,16 L0.800307005,16 C0.358309651,16 2.27317719e-14,15.6440617 2.27317719e-14,15.1994822 L0,11.8664697 C0,11.6441494 0.128055431,11.3359446 0.282065108,11.1820273 L11.0029288,0.467594363 C11.6273402,-0.156442485 12.6398354,-0.15581956 13.2646091,0.469194741 Z"}));
}

Pencil.displayName = "Pencil";

Pencil.defaultProps = {"viewBox":"0 0 16 16","version":"1.1"};

module.exports = Pencil;

Pencil.default = Pencil;



//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/assets/icons/pencil.svg
// module id = 2718
// module chunks = 5 14